(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('pixelforma-wishlist-button')) {
    customElements.define('pixelforma-wishlist-button', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button || this.button.dataset.wishlistReady === 'true') return;
        this.button.dataset.wishlistReady = 'true';
        this.storageKey = 'pixelformaWishlist';
        this.button.addEventListener('click', () => this.toggle());
        this.render();
      }

      read() {
        try {
          const value = JSON.parse(localStorage.getItem(this.storageKey) || '[]');
          return Array.isArray(value) ? value : [];
        } catch (error) {
          return [];
        }
      }

      toggle() {
        const values = this.read();
        const active = values.includes(this.dataset.handle);
        const nextValues = active
          ? values.filter((handle) => handle !== this.dataset.handle)
          : [...values, this.dataset.handle];
        localStorage.setItem(this.storageKey, JSON.stringify(nextValues));
        this.render();
      }

      render() {
        const active = this.read().includes(this.dataset.handle);
        const label = active ? this.button.dataset.removeLabel : this.button.dataset.addLabel;
        this.button.setAttribute('aria-pressed', String(active));
        this.button.querySelector('span').textContent = label;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pixelforma-header"]) return;
  try {
    document.querySelectorAll('.pf-search').forEach((form)=>{form.addEventListener('submit',(event)=>{const input=form.querySelector('.js-search-input');if(window.matchMedia('(max-width: 950px)').matches&&input&&input.value.trim()===''){event.preventDefault();input.focus();}});});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pixelforma-product"]) return;
  try {
    
document.addEventListener('change',function(event){if(!event.target.matches('.pf-product-form input[type="radio"]'))return;const wrapper=event.target.closest('[data-pf-product-form]');if(!wrapper)return;const form=wrapper.querySelector('.pf-product-form');let variants;try{variants=JSON.parse(wrapper.dataset.variants);}catch(error){return;}const selected=Array.from(form.querySelectorAll('fieldset')).map(function(fieldset){const input=fieldset.querySelector('input[type="radio"]:checked');return input?input.value:'';});const variant=variants.find(function(item){return item.options.every(function(value,index){return value===selected[index];});});if(!variant)return;form.querySelector('[data-pf-variant-id]').value=variant.id;const button=form.querySelector('.pf-add');button.disabled=!variant.available;button.textContent=variant.available?wrapper.dataset.addLabel:wrapper.dataset.unavailableLabel;});
document.addEventListener('DOMContentLoaded',function(){const button=document.querySelector('[data-pf-wishlist]');if(!button)return;const storageKey='pixelformaWishlist';const read=function(){try{return JSON.parse(localStorage.getItem(storageKey)||'[]');}catch(error){return[];}};const paint=function(){const active=read().includes(button.dataset.handle);button.classList.toggle('is-active',active);button.setAttribute('aria-pressed',active?'true':'false');button.querySelector('span').textContent=active?button.dataset.removeLabel:button.dataset.addLabel;};button.addEventListener('click',function(){const items=read();const index=items.indexOf(button.dataset.handle);if(index===-1)items.push(button.dataset.handle);else items.splice(index,1);localStorage.setItem(storageKey,JSON.stringify(items));paint();});paint();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pixelforma-wishlist"]) return;
  try {
    document.addEventListener('DOMContentLoaded',async function(){const root=document.querySelector('[data-pf-wishlist-page]');if(!root)return;const key='pixelformaWishlist';const grid=root.querySelector('[data-pf-wishlist-grid]');const empty=root.querySelector('[data-pf-wishlist-empty]');const removeLabel=root.dataset.removeLabel||'Remove from wishlist';const read=function(){try{return JSON.parse(localStorage.getItem(key)||'[]');}catch(error){return[];}};const money=function(cents){return new Intl.NumberFormat(document.documentElement.lang||'fr-FR',{style:'currency',currency:'EUR'}).format(cents/100);};const render=async function(){const handles=read();grid.innerHTML='';empty.hidden=handles.length>0;if(!handles.length)return;const products=await Promise.all(handles.map(async function(handle){try{const response=await fetch('/products/'+encodeURIComponent(handle)+'.js');return response.ok?response.json():null;}catch(error){return null;}}));products.filter(Boolean).forEach(function(product){const article=document.createElement('article');article.className='pf-wishlist-card';article.innerHTML='<a href="'+product.url+'"><span class="pf-wishlist-card__image"><img src="'+product.featured_image+'" alt=""></span><h2></h2><p>'+money(product.price)+'</p></a><button class="pf-wishlist-remove" type="button" aria-label="'+removeLabel.replace(/"/g,'&quot;')+'" data-handle="'+product.handle+'"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.8-7.5 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z"/></svg></button>';article.querySelector('h2').textContent=product.title;grid.appendChild(article);});empty.hidden=grid.children.length>0;};grid.addEventListener('click',function(event){const button=event.target.closest('[data-handle]');if(!button)return;localStorage.setItem(key,JSON.stringify(read().filter(function(handle){return handle!==button.dataset.handle;})));render();});render();});
  } catch(e) { console.error(e); }
})();
})();
